import '../../App.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'

function SectionAdd() {
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    const [addData, setAddData] = useState({})
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }
    let navigate = useNavigate()
    useEffect(() => {
        if (user.role !== 'human_resource' && user.role !== 'management') {
            localStorage.removeItem('authResult')
            navigate('/login')
        }
    }, [])

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'name':
                setAddData({ ...addData, name: e.target.value })
                break
            case 'userId':
                setAddData({ ...addData, userId: e.target.value })
                break

            default:
                return null
        }
    }

    console.log(addData)

    useEffect(() => {
        setLoading(true)
        axios
            .get(`http://188.121.105.111:3000/user`)
            .then((res) => {
                setDataGet(res.data)
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
            })
    }, [])

    const handlerSubmit = () => {
        setLoading(true)

        axios
            .post(`http://188.121.105.111:3000/sections/`, addData)
            .then((res) => {
                axios
                    .patch(
                        `http://188.121.105.111:3000/user/${addData.userId}`,
                        {
                            role: 'section',
                            supervisor: true,
                            roleChildId: null,
                        }
                    )
                    .then((res) => {
                        navigate('/sections')
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false)
                    })
            })
            .catch((error) => {
                setLoading(false)
            })
    }
    const handlerCancel = () => {
        navigate(-1)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box">
                        <div className="header-container">
                            <h3 className="section-header">افزودن بخش</h3>
                        </div>

                        <div className="flex flex-col w-25 m-2">
                            <lablel>نام بخش:</lablel>
                            <input
                                className="input m-1"
                                type="text"
                                onChange={(e) => {
                                    setQueryPropertyAddData('name', e)
                                }}
                            />
                        </div>

                        <div className="flex flex-col w-25 m-2">
                            <label>سرپرست بخش</label>
                            <select
                                id="substitutePersonId"
                                className="input"
                                style={{ width: '200px' }}
                                name="substitutePersonId"
                                onChange={(e) => {
                                    setQueryPropertyAddData('userId', e)
                                }}
                            >
                                <option value="none" selected>
                                    انتخاب کنید
                                </option>
                                {dataGet.map((d) => {
                                    return (
                                        <option value={d.id}>
                                            {d.fullName}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="flex w-full">
                            <button
                                className="btn main-clr-bg w-50 m-2 white-clr font-bold"
                                onClick={handlerSubmit}
                            >
                                ثبت
                            </button>
                            <button
                                className="btn red-clr-bg w-50 m-2 white-clr font-bold"
                                onClick={handlerCancel}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default SectionAdd
